// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__4LJ7f","breadcrumbItem":"Breadcrumbs_breadcrumbItem__tLZrD"};